import { Alert, Button } from '@mui/material'
import { useDrawersContext } from 'components/context/ClientsDrawersProvider'

export function SubscriptionGlobalWarning() {
  const { handleOpenMySubscription } = useDrawersContext()

  return (
    <Alert
      severity="warning"
      sx={{ borderRadius: 0 }}
      action={
        <Button color="inherit" size="small" onClick={handleOpenMySubscription}>
          Manage Subscription
        </Button>
      }
    >
      Your last payment could not be processed. Open My Subscription to update your card or pay now.
    </Alert>
  )
}
